import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/BoltSmallRectangleColorViolet.tsx
const BoltSmallRectangleColorVioletIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm7.778 3.018c.159.049.266.189.266.347v4.018h3.571c.145 0 .277.077.343.2a.35.35 0 0 1-.032.38l-5.274 6.887a.396.396 0 0 1-.43.132.368.368 0 0 1-.266-.347v-4.018H7.385a.387.387 0 0 1-.343-.2.35.35 0 0 1 .032-.38l5.274-6.887a.396.396 0 0 1 .43-.132Z",
		fill: "url(#paint0_linear_421_177)"
	}), /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", {
		id: "paint0_linear_421_177",
		x1: 3,
		y1: 12,
		x2: 21,
		y2: 12,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ jsx("stop", { stopColor: "#8478FF" }), /* @__PURE__ */ jsx("stop", {
			offset: 1,
			stopColor: "#3DA9FF"
		})]
	}) })]
}));
//#endregion
export { BoltSmallRectangleColorVioletIcon };
